import React from 'react';
import styled from 'astroturf/react';

import { $image_url, User } from 'js/utils';
import _UserButton from "SmallAccountMenuButton-UserButton.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/CoreXNav/SmallAccountMenuButton.tsx?styleId=UserButton";
import _ButtonProfilePic from "SmallAccountMenuButton-ButtonProfilePic.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/CoreXNav/SmallAccountMenuButton.tsx?styleId=ButtonProfilePic";


const UserButton = /*#__PURE__*/styled("button", null, {
  displayName: "UserButton",
  styles: _UserButton
});

const ButtonProfilePic = /*#__PURE__*/styled("img", null, {
  displayName: "ButtonProfilePic",
  styles: _ButtonProfilePic
});

type Props = {
  menuOpen: boolean;
  setMenuOpen: (openness: boolean) => void;
};

const AccountMenuButton = ({ menuOpen, setMenuOpen }: Props) => {
  const toggle = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <UserButton onClick={toggle} aria-pressed={menuOpen}>
      {User.current != null && (
        <ButtonProfilePic src={$image_url(User.current.photo)} />
      )}
    </UserButton>
  );
};

export default AccountMenuButton;
